import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';

const { podiumCdsColorGrey300, podiumCdsColorTextPrimary, podiumCdsTransitionDurationNormal } = nike;

const progressBarContainerCSS = styled('div');
export const ProgressBarContainerCss = progressBarContainerCSS`
    height: 5px;
    width: 100%;
    background-color: ${podiumCdsColorGrey300};
    border-radius: 10px;
    text-align: center;
`;

const progressBarCSS = styled('div');
export const ProgressBarCss = progressBarCSS`
    height: 100%;
    width: ${({ completed = 0, max = 100 }) => (completed <= max ? completed : max)}%;
    background-color: ${podiumCdsColorTextPrimary};
    border-radius: inherit;
    transition: width ${podiumCdsTransitionDurationNormal} ease-in-out;
`;
